import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { ApiRequestService, ListViewComponent, TranslationPipe } from '@prekog/common-ui';
import { GetNoveltyProductsResponse } from './get-novelty-products.response';
import { NoveltyProduct } from './novelty-product.model';
import { UpdateNoveltyProductsOrderRequest } from './update-novelty-products-order.request';

@Component({
    selector: 'pf-order-novelty-products',
    templateUrl: './order-novelty-products.component.html',
    styleUrls: ['./order-novelty-products.component.scss'],
    standalone: true,
    imports: [MatIconModule, FormsModule, RouterModule, DragDropModule, CommonModule, TranslationPipe, DragDropModule, ListViewComponent, ListViewComponent]
})
export class OrderNoveltyProductsComponent implements OnInit {
    noveltyProducts?: NoveltyProduct[];
    filteredNoveltyProducts?: NoveltyProduct[];
    getNoveltyProductsURL = '/admin/getNoveltyProductsForOrdering';

    searchText = '';
    storeBaseUrl = '';
    updateNoveltyProductsOrderURL = '/admin/updateNoveltyProductsOrder';

    constructor(
        @Inject('STORE_BACKEND_URL') private _storeBaseUrl: string,
        private _apiRequestService: ApiRequestService
    ) {
        this.storeBaseUrl = _storeBaseUrl;
    }

    ngOnInit(): void {
        this.getNoveltyProducts();
    }

    getNoveltyProducts() {
        this._apiRequestService
            .sendRequest<{}, GetNoveltyProductsResponse>(this.storeBaseUrl, {}, true, this.getNoveltyProductsURL)
            .subscribe((response) => {
                this.noveltyProducts = response.noveltyProductList as NoveltyProduct[];
                this.filteredNoveltyProducts = this.noveltyProducts;
            });
    }

    drop(event: CdkDragDrop<NoveltyProduct>): void {
        moveItemInArray(this.noveltyProducts!, event.previousIndex, event.currentIndex);
    }

    updateNoveltyProductsOrder() {
        const updateNoveltyProductsOrderRequest: UpdateNoveltyProductsOrderRequest = {
            noveltyProductOrderList: this.noveltyProducts!.map((noveltyProduct, index) => ({
                productId: noveltyProduct.productId,
                orderNumber: index
            }))
        };

        this._apiRequestService
            .sendRequest<
                {},
                GetNoveltyProductsResponse
            >(this.storeBaseUrl, updateNoveltyProductsOrderRequest, true, this.updateNoveltyProductsOrderURL, true)
            .subscribe();
    }
}
